import { WhitelabelEvent } from "../../interfaces/event/whitelabelEvent";

export const mockWL: WhitelabelEvent = {
  header: {
    background: "",
    color: "",
    login: {
      background: "",
      color: "",
      disabled: false,
      title: ""
    },
    logo: {
      alt: "",
      url: "",
    },
    menu: {
      itens: []
    },
    register: {
      title: "",
      background: "",
      color: "",
      disabled: false,
    },
  },
  body: {
    hero: {
      menu: false,
      type: "hero",
      index: 1,
      options: {
        positionX: "center",
        positionY: "center",
        backgroudColor: "",
        backgroudImage: "",
        imageMobile: "",
        text: {
          position: "center",
          text: "",
          color: "",
          icon: "",
        }
      },
    },
    cta: {
      menu: false,
      type: "cta",
      index: 6,
      options: {
        itens: {
          button: {
            href: "",
            title: "",
            backgroudColor: "",
            color: "",
            disabled: false,
          },
          backgroudColor: "",
          backgroudImage: "",
          color: "",
          positionX: "center",
          positionY: "center",
          text: {
            align: "center",
            description: "",
            title: ""
          }
        }
      },
    },
    box: {
      menu: false,
      type: "box",
      index: 2,
      options: [{
        position: "left",
        text: {
          align: "center",
          description: "",
          positionX: "center",
          positionY: "center",
          title: "",
        }
      }],
    },
    speakers: {
      menu: false,
      type: "speakers",
      itens: [],
      index: 4
    },
    calendar: {
      itens: [],
      type: "calendar",
      menu: false,
      index: 3,
    },
    sponsors: {
      itens: [],
      type: "sponsors",
      menu: false,
      index: 5
    },
    loginAndRegister: {
      type: "loginAndRegister",
      menu: false,
      options: {
        button: {
          background: "",
          color: "",
          title: "",
        },
        image: "",
        text: {
          positionX: "center",
          positionY: "center",
          align: "center",
          title: "",
        }
      }
    },
  },
  footer: {
    background: "",
    color: "",
    logo: "",
    social: {
      color: "",
      format: "round",
      background: "",
      itens: {
        facebook: {active: false, url: ""},
        instagram: {active: false, url: ""},
        X: {active: false, url: ""},
        youtube: {active: false, url: ""},
        linkedin: {active: false, url: ""},
        threads: {active: false, url: ""},
        tiktok: {active: false, url: ""},
      }
    },
  },
  config: {
    redundancy: {
      is_active: false
    },
    theme: 'light'
  },
  isPublic: true,
  name: 'teste mock'
};
